import { render, staticRenderFns } from "./resource-overview.vue?vue&type=template&id=d89fa88a&"
import script from "./resource-overview.vue?vue&type=script&lang=js&"
export * from "./resource-overview.vue?vue&type=script&lang=js&"
import style0 from "./resource-overview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports